import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('iscrittiNewsletter');
export const actions = helper.createActions('iscrittiNewsletter', actionTypes);